import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink } from '../DataTypes/linkMapper';
import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'contactList';
		properties: {
			heading: string;
			link: Umbraco.Link[];
			contacts: Umbraco.ContactPerson[];
		};
	};
}

export const mapContactList = ({ content }: Props): Content.ContactList => {
	const { heading, link, contacts: contactItems } = content?.properties ?? {};

	try {
		return {
			documentType: content?.contentType,
			content: {
				heading,
				link: mapFirstLink(link),
				contacts: contactItems?.map((contact) => {
					const { contactPersonPageLink, description, email, image, organisation, phone, title } = contact?.properties ?? {};
					const { name: linkName, route } = contactPersonPageLink?.[0] ?? {};
					return {
						name: contact?.name,
						description: description?.markup || null,
						image: mapFirstImage(image),
						organisation,
						title,
						email,
						phone,
						contactPersonPageLink: route ? { url: route.path, name: linkName } : null,
					};
				}),
			},
		};
	} catch (e) {
		logger.error('Could not map Organisation List', e);
		throw new Error('Could not map Organisation List', e);
	}
};
